import { useStaticQuery, graphql } from 'gatsby'

export function useDataSixthScreenByEn() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageMain(title: { eq: "Slide 6: Title small" }, locale: { eq: "en" }) {
                value
            }

            title: datoCmsRenshinPageMain(title: { eq: "Slide 6: Title" }, locale: { eq: "en" }) {
                value
            }

            buttonText: datoCmsRenshinPageMain(title: { eq: "Slide 6: Button" }, locale: { eq: "en" }) {
                value
            }

            projects: allDatoCmsRenshinProject(filter: { locale: { eq: "en" } }) {
                nodes {
                    title
                    urlCode
                    previewPictureDesktop {
                        url
                    }
                }
            }
        }
    `)

    return data
}
